import { NodesType } from 'src/domains/common/components/multi-option-select/multi-option-select';

export const BET_TYPE_OPTIONS: NodesType[] = [
    {
        id: 'popular',
        value: 'popular',
        label: 'Popular',
        children: [
            { id: 'SGL', value: 'SGL', label: 'Single' },
            { id: 'SGLBG', value: 'SGLBG', label: 'Single - BG' },
            {
                id: 'BB',
                value: 'BB',
                label: 'Build-A-Bet (Bet Genius Multibet)',
            },
            {
                id: 'RAB',
                value: 'RAB',
                label: 'Build-A-Bet (RAB)',
            },
            { id: 'TRX', value: 'TRX', label: 'Trixie' },
            { id: 'PAT', value: 'PAT', label: 'Patent' },
            { id: 'YAN', value: 'YAN', label: 'Yankee' },
            { id: 'L15', value: 'L15', label: 'Lucky 15' },
            { id: 'CAN', value: 'CAN', label: 'Canadian' },
            { id: 'HNZ', value: 'HNZ', label: 'Heinz' },
            { id: 'L63', value: 'L63', label: 'Lucky 63' },
            { id: 'SHNZ', value: 'SHNZ', label: 'Super Heinz' },
            { id: 'GOL', value: 'GOL', label: 'Goliath' },
            { id: 'DBL', value: 'DBL', label: 'Double' },
            { id: 'TBL', value: 'TBL', label: 'Treble (3-Leg Parlay)' },
            { id: '4F', value: '4F', label: '4 Fold (4-Leg Parlay)' },
            { id: '5F', value: '5F', label: '5 Fold (5-Leg Parlay)' },
            { id: '6F', value: '6F', label: '6 Fold (6-Leg Parlay)' },
            { id: '7F', value: '7F', label: '7 Fold (7-Leg Parlay)' },
            { id: '8F', value: '8F', label: '8 Fold' },
            { id: '9F', value: '9F', label: '9 Fold' },
            { id: '10F', value: '10F', label: '10 Fold' },
            { id: '11F', value: '11F', label: '11 Fold' },
            { id: '12F', value: '12F', label: '12 Fold' },
            { id: '13F', value: '13F', label: '13 Fold' },
            { id: '14F', value: '14F', label: '14 Fold' },
            { id: '15F', value: '15F', label: '15 Fold' },
            { id: '16F', value: '16F', label: '16 Fold' },
            { id: '17F', value: '17F', label: '17 Fold' },
            { id: '18F', value: '18F', label: '18 Fold' },
            { id: '19F', value: '19F', label: '19 Fold' },
            { id: '20F', value: '20F', label: '20 Fold' },
            { id: '21F', value: '21F', label: '21 Fold' },
            { id: '22F', value: '22F', label: '22 Fold' },
            { id: '23F', value: '23F', label: '23 Fold' },
            { id: '24F', value: '24F', label: '24 Fold' },
            { id: '25F', value: '25F', label: '25 Fold' },
        ],
    },
    {
        id: 'others',
        value: 'others',
        label: 'Others',
        children: [
            { id: '2F3', value: '2F3', label: 'Doubles from 3' },
            { id: '2F4', value: '2F4', label: 'Doubles from 4' },
            { id: '3F4', value: '3F4', label: 'Trebles from 4' },
            { id: '2F5', value: '2F5', label: 'Doubles from 5' },
            { id: '3F5', value: '3F5', label: 'Trebles from 5' },
            { id: '4F5', value: '4F5', label: '4 Folds from 5' },
            { id: '2F6', value: '2F6', label: 'Doubles from 6' },
            { id: '3F6', value: '3F6', label: 'Trebles from 6' },
            { id: '4F6', value: '4F6', label: '4 Folds from 6' },
            { id: '5F6', value: '5F6', label: '5 Folds from 6' },
            { id: '2F7', value: '2F7', label: 'Doubles from 7' },
            { id: '3F7', value: '3F7', label: 'Trebles from 7' },
            { id: '4F7', value: '4F7', label: '4 Folds from 7' },
            { id: '5F7', value: '5F7', label: '5 Folds from 7' },
            { id: '6F7', value: '6F7', label: '6 Folds from 7' },
            { id: '2F8', value: '2F8', label: 'Doubles from 8' },
            { id: '3F8', value: '3F8', label: 'Trebles from 8' },
            { id: '4F8', value: '4F8', label: '4 Folds from 8' },
            { id: '5F8', value: '5F8', label: '5 Folds from 8' },
            { id: '6F8', value: '6F8', label: '6 Folds from 8' },
            { id: '7F8', value: '7F8', label: '7 Folds from 8' },
            { id: '2F9', value: '2F9', label: 'Doubles from 9' },
            { id: '3F9', value: '3F9', label: 'Trebles from 9' },
            { id: '8F9', value: '8F9', label: '8 Folds from 9' },
            { id: '2F10', value: '2F10', label: 'Doubles from 10' },
            { id: '3F10', value: '3F10', label: 'Trebles from 10' },
            { id: '9F10', value: '9F10', label: '9 Folds from 10' },
            { id: '2F11', value: '2F11', label: 'Doubles from 11' },
            { id: '3F11', value: '3F11', label: 'Trebles from 11' },
            { id: '10F11', value: '10F11', label: '10 Folds from 11' },
            { id: '2F12', value: '2F12', label: 'Doubles from 12' },
            { id: '3F12', value: '3F12', label: 'Trebles from 12' },
            { id: '11F12', value: '11F12', label: '11 Folds from 12' },
            { id: '2F13', value: '2F13', label: 'Doubles from 13' },
            { id: '3F13', value: '3F13', label: 'Trebles from 13' },
            { id: '12F13', value: '12F13', label: '12 Folds from 13' },
            { id: '2F14', value: '2F14', label: 'Doubles from 14' },
            { id: '3F14', value: '3F14', label: 'Trebles from 14' },
            { id: '13F14', value: '13F14', label: '13 Folds from 14' },
            { id: '2F15', value: '2F15', label: 'Doubles from 15' },
            { id: '3F15', value: '3F15', label: 'Trebles from 15' },
            { id: '14F15', value: '14F15', label: '14 Folds from 15' },
            { id: '2F16', value: '2F16', label: 'Doubles from 16' },
            { id: '3F16', value: '3F16', label: 'Trebles from 16' },
            { id: '15F16', value: '15F16', label: '15 Folds from 16' },
            { id: '2F17', value: '2F17', label: 'Doubles from 17' },
            { id: '3F17', value: '3F17', label: 'Trebles from 17' },
            { id: '16F17', value: '16F17', label: '16 Folds from 17' },
            { id: '2F18', value: '2F18', label: 'Doubles from 18' },
            { id: '3F18', value: '3F18', label: 'Trebles from 18' },
            { id: '17F18', value: '17F18', label: '17 Folds from 18' },
            { id: '2F19', value: '2F19', label: 'Doubles from 19' },
            { id: '3F19', value: '3F19', label: 'Trebles from 19' },
            { id: '18F19', value: '18F19', label: '18 Folds from 19' },
            { id: '2F20', value: '2F20', label: 'Doubles from 20' },
            { id: '3F20', value: '3F20', label: 'Trebles from 20' },
            { id: '19F20', value: '19F20', label: '19 Folds from 20' },
            { id: '2F21', value: '2F21', label: 'Doubles from 21' },
            { id: '3F21', value: '3F21', label: 'Trebles from 21' },
            { id: '20F21', value: '20F21', label: '20 Folds from 21' },
            { id: '2F22', value: '2F22', label: 'Doubles from 22' },
            { id: '3F22', value: '3F22', label: 'Trebles from 22' },
            { id: '21F22', value: '21F22', label: '21 Folds from 22' },
            { id: '2F23', value: '2F23', label: 'Doubles from 23' },
            { id: '3F23', value: '3F23', label: 'Trebles from 23' },
            { id: '22F23', value: '22F23', label: '22 Folds from 23' },
            { id: '2F24', value: '2F24', label: 'Doubles from 24' },
            { id: '3F24', value: '3F24', label: 'Trebles from 24' },
            { id: '23F24', value: '23F24', label: '23 Folds from 24' },
            { id: '2F25', value: '2F25', label: 'Doubles from 25' },
            { id: '3F25', value: '3F25', label: 'Trebles from 25' },
            { id: '24F25', value: '24F25', label: '24 Folds from 25' },
        ],
    },
    {
        id: 'horse-dog-racing',
        value: 'horse-dog-racing',
        label: 'Horse/Dog Racing',
        children: [
            { id: 'FC', value: 'FC', label: 'Forecast' },
            { id: 'RFC', value: 'RFC', label: 'Reverse Forecast' },
            { id: 'TC', value: 'TC', label: 'Tricast' },
            { id: 'CFC', value: 'CFC', label: 'Combination Forecast' },
            { id: 'CTC', value: 'CTC', label: 'Combination Tricast' },
        ],
    },
];

export type ExpirationTimeType = 'absolute-expiry' | 'relative-expiry';

export interface AllExpirationTimeType {
    value: ExpirationTimeType;
    label: string;
}

export const EXPIRY_OPTIONS: Array<AllExpirationTimeType> = [
    { value: 'absolute-expiry', label: 'Absolute Expiry' },
    { value: 'relative-expiry', label: 'Relative Expiry' },
];
